export const CONDITION_POPUP = 'CONDITION_POPUP'
export const CONDITION_POPUP_NEW = 'CONDITION_POPUP_NEW'
export const CVV_INFO_POPUP = 'CVV_INFO_POPUP'
export const GLOBAL_ERROR_POPUP = 'GLOBAL_ERROR_POPUP'
export const LAST_CHANCE_POPUP = 'LAST_CHANCE_POPUP'
export const GLOBAL_ERROR_POPUP_SMSWENTWRNG = 'GLOBAL_ERROR_POPUP_SMSWENTWRNG'
export const MULTIPLE_CONFIRMATION = 'MULTIPLE_CONFIRMATION'
export const APPARTMENT_OPTION_DETAILS = 'APPARTMENT_OPTION_DETAILS'
export const GALLERY_POPUP = 'GALLERY_POPUP'
export const FAMILY_POPUP = 'FAMILY_POPUP'
export const ROOM_POPUP = 'ROOM_POPUP';
export const BREAKFAST_POPUP = 'BREAKFAST_POPUP';
export const PARKING_POPUP = 'PARKING_POPUP';

// Events
export const OPEN_EVENT_KEY = 'reactModalOpen'
export const CLOSE_EVENT_KEY = 'reactModalClose'

export const CHANGE_POPUP_CACHE = 'CHANGE_POPUP_CACHE';
